/**
 * Decks API slice.
 * Leaf module (Perf 3.1.b/e Step 5). Pulls only the shared chokepoint from
 * ./client; never imports a sibling @/lib/api slice.
 */
import { fetchWithAuth } from './client';

export const decksApi = {
  list: async () => fetchWithAuth('/json/decks'),

  // Create a deck. Pass `templateSlug` to seed from a recipe.
  create: async ({ name, description, icon, columns, templateSlug, templateId } = {}) => {
    return fetchWithAuth('/json/decks', {
      method: 'POST',
      body: { name, description, icon, columns, templateSlug, templateId },
    });
  },

  getBySlug: async (slug) => {
    return fetchWithAuth(`/json/decks/${encodeURIComponent(slug)}`);
  },

  // Server-side allow-list: name, description, icon, columns, flags, slug (UUID only).
  update: async (slug, patch = {}) => {
    return fetchWithAuth(`/json/decks/${encodeURIComponent(slug)}`, {
      method: 'PUT',
      body: patch,
    });
  },

  delete: async (slug) => {
    return fetchWithAuth(`/json/decks/${encodeURIComponent(slug)}`, {
      method: 'DELETE',
    });
  },

  // Reorder all decks. Pass slugs in the desired tab order.
  reorder: async (order = []) => {
    return fetchWithAuth('/json/decks/reorder', {
      method: 'POST',
      body: { order },
    });
  },
};
